import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import Table from "../../../_common/Table";
import EquipmentDetails from "./EquipmentDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditEquipmentModal from "./EditEquipmentModal";
import MergeEquipmentModal from "./MergeEquipmentModal";
import EquipmentUploadModal from "./EquipmentUploadModal";
import AlertModal from "../../../_common/AlertModal";
import equipmentActions from "../../../../_actions/equipmentActions";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import contractorActions from "../../../../_actions/contractorActions";

class EquipmentList extends Component {
  state = {
    contractorFilter: null,
    equipFilter: "",
    selectedEquipmentId: 0,
    sortColumn: { path: "makeDesc", order: "asc" },
    showEditEquipModal: false,
    isNew: false,
    showAlert_deleteEquipment: false,
    showMergeEquipModal: false,
    showUploadModal: false,
    viewMode: "inProject", // "inProject" | "allAvailable"
  };

  columns = [
    {
      path: "number",
      label: "No.",
      content: (equip) => (
        <div>
          <div>{equip.number}</div>
          {equip.isLinked && (
            <span className="badge badge-success">In Project</span>
          )}
        </div>
      ),
      thClassName: "",
    },
    {
      path: "makeDesc",
      label: "Class / Make / Model Code",
      content: (equip) => {
        const classMakeCode = [equip.equipmentClass, equip.equipmentMake, equip.equipmentModel]
          .filter(Boolean)
          .join(" / ");
        return (
          <div>
            {classMakeCode && <div>{classMakeCode}</div>}
            {equip.description && <small className="text-muted">{equip.description}</small>}
          </div>
        );
      },
      thClassName: "",
    },
    {
      path: "contractorName",
      label: "Contractor",
      content: (equip) => this.getContractorName(equip.contractorId),
      thClassName: "",
    },
    {
      path: "isManualEntry",
      label: "Type",
      content: (equip) => {
        if (equip.isManualEntry) return <span className="badge badge-secondary">Manual</span>;
        if (equip.equipmentType === "E") return <span className="badge badge-info">Standard</span>;
        if (equip.equipmentType === "M") return <span className="badge badge-warning">Misc</span>;
        return null;
      },
      thClassName: "",
    },
  ];

  componentDidMount() {
    const { projectId, dispatch } = this.props;
    dispatch(equipmentActions.getAll(projectId));
    dispatch(contractorActions.getAllForProject(projectId));
  }

  getContractorName = (ctrId) => {
    const { projContractorList } = this.props;
    const ctr = (projContractorList || []).find((c) => c.contractorId === ctrId);
    return ctr ? ctr.name : "(N/A)";
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleChange_contractorFilter = (contractorFilter) =>
    this.setState({ contractorFilter });
  handleChange_equipFilter = (e) => this.setState({ equipFilter: e.target.value });

  handleChange_viewMode = (viewMode) => {
    if (viewMode === "allAvailable") {
      const { projectId, dispatch, allAvailableEquipList } = this.props;
      if (!allAvailableEquipList) dispatch(equipmentActions.getAllAvailable(projectId));
    }
    this.setState({ viewMode, selectedEquipmentId: 0 });
  };

  getData = () => {
    const { projEquipList, allAvailableEquipList } = this.props;
    const { contractorFilter, equipFilter, sortColumn, viewMode } = this.state;
    const sourceList = viewMode === "allAvailable" ? allAvailableEquipList : projEquipList;

    const filteredByContractor =
      contractorFilter !== null
        ? (sourceList || []).filter((e) => e.contractorId === contractorFilter.value)
        : sourceList || [];
    const filteredByEquip =
      equipFilter !== ""
        ? filteredByContractor.filter((e) => {
            const searchable = [e.number, e.equipmentClass, e.equipmentMake, e.equipmentModel, e.description]
              .filter(Boolean)
              .join(" ")
              .toLowerCase();
            return searchable.includes(equipFilter.trim().toLowerCase());
          })
        : filteredByContractor;
    const withNames = filteredByEquip.map((e) => ({
      ...e,
      contractorName: this.getContractorName(e.contractorId),
    }));
    return _.orderBy(withNames, [sortColumn.path], [sortColumn.order]);
  };

  handleClick_equipTr = (selectedEquipment) => {
    this.setState({ selectedEquipmentId: selectedEquipment.equipmentId });
  };

  toggleEditEquipModal = () =>
    this.setState({ showEditEquipModal: !this.state.showEditEquipModal });

  toggleAlert_deleteEquipment = () =>
    this.setState({ showAlert_deleteEquipment: !this.state.showAlert_deleteEquipment });

  handleAlert_deleteEquipment = (alertAction) => (e) => {
    e.preventDefault();
    if (alertAction === "accept") this.deleteEquipment();
    this.toggleAlert_deleteEquipment();
  };

  editEquipment = () => {
    this.setState({ isNew: false });
    this.toggleEditEquipModal();
  };

  toggleMergeEquipModal = () =>
    this.setState({ showMergeEquipModal: !this.state.showMergeEquipModal });

  toggleUploadModal = () =>
    this.setState({ showUploadModal: !this.state.showUploadModal });

  handleMergeSuccess = () =>
    this.setState({ showMergeEquipModal: false, selectedEquipmentId: 0 });

  deleteEquipment = () => {
    const { dispatch, projectId, projEquipList } = this.props;
    const { selectedEquipmentId } = this.state;
    const equipmentToDelete = (projEquipList || []).find(
      (e) => e.equipmentId === selectedEquipmentId
    );
    this.setState({ selectedEquipmentId: 0 }, () =>
      dispatch(
        equipmentActions.deleteEquipment(
          selectedEquipmentId,
          projectId,
          equipmentToDelete ? equipmentToDelete.contractorId : null
        )
      )
    );
  };

  renderTableFilters = () => {
    const { equipFilter, contractorFilter, viewMode } = this.state;
    const { permissions, projContractorList, projectId, dispatch } = this.props;
    return (
      <React.Fragment>
      <div className="d-flex flex-row flex-wrap pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="equipFilter"
              id="equipFilter"
              className="form-control mr-2"
              value={equipFilter}
              onChange={this.handleChange_equipFilter}
              placeholder="No / Make / Code / Desc."
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__select pa-filter-item__select--contractor mr-2">
          <Select
            name="contractorFilter"
            id="contractorFilter"
            value={contractorFilter}
            options={projContractorList && getProjContractorOptions(projContractorList)}
            onChange={this.handleChange_contractorFilter}
            isSearchable={false}
            isClearable
            placeholder="Contractor"
          />
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addNewEquip"
            id="addNewEquip"
            className="btn btn-info px-2"
            onClick={() =>
              this.setState({
                isNew: true,
                selectedEquipmentId: 0,
                showEditEquipModal: true,
              })
            }
            disabled={!permissions.includes(docPermConstants.EDIT)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
      </div>
      <div className="d-flex flex-row flex-wrap pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__btn mr-2">
          <div className="btn-group btn-group-sm" role="group">
            <button
              type="button"
              className={`btn ${viewMode === "inProject" ? "btn-primary" : "btn-outline-secondary"}`}
              onClick={() => this.handleChange_viewMode("inProject")}
            >
              In Project
            </button>
            <button
              type="button"
              className={`btn ${viewMode === "allAvailable" ? "btn-primary" : "btn-outline-secondary"}`}
              onClick={() => this.handleChange_viewMode("allAvailable")}
            >
              All Available
            </button>
          </div>
        </div>
        {/*
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="uploadCsvEquip"
            id="uploadCsvEquip"
            className="btn btn-outline-info px-2"
            onClick={this.toggleUploadModal}
            disabled={!permissions.includes(docPermConstants.EDIT)}
          >
            <FontAwesomeIcon icon="upload" className="fa-fw mr-2" />
            Upload CSV
          </button>
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="downloadCsvEquip"
            id="downloadCsvEquip"
            className="btn btn-outline-secondary px-2"
            onClick={() => dispatch(equipmentActions.downloadCsv(projectId))}
          >
            <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
            Download CSV
          </button>
        </div>
        */}
      </div>
      </React.Fragment>
    );
  };

  render() {
    const {
      selectedEquipmentId,
      sortColumn,
      showEditEquipModal,
      isNew,
      showAlert_deleteEquipment,
      showMergeEquipModal,
      showUploadModal,
    } = this.state;
    const { projectId } = this.props;
    const data = this.getData();
    const selectedEquipment = data.find((e) => e.equipmentId === selectedEquipmentId);
    return (
      <React.Fragment>
        <div className="d-flex flex-row p-2 w-100">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-hover table-sm pa-list__table"
                data={data}
                idPropName="equipmentId"
                selectedItemId={selectedEquipmentId || undefined}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_equipTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card w-100 sticky-top top-margin-30">
              <div className="card-header">Equipment Details</div>
              <div className="card-body p-3">
                <EquipmentDetails
                  projectId={projectId}
                  equipmentId={selectedEquipmentId}
                  viewMode={this.state.viewMode}
                  editEquipment={this.editEquipment}
                  mergeEquipment={this.toggleMergeEquipModal}
                  toggleAlert_deleteEquipment={this.toggleAlert_deleteEquipment}
                />
              </div>
            </div>
          </div>
        </div>
        {showMergeEquipModal && selectedEquipment && (
          <MergeEquipmentModal
            projectId={projectId}
            sourceEquipment={selectedEquipment}
            showModal={showMergeEquipModal}
            toggleModal={this.toggleMergeEquipModal}
            onMergeSuccess={this.handleMergeSuccess}
          />
        )}
        {showEditEquipModal && (
          <EditEquipmentModal
            projectId={projectId}
            equipmentId={selectedEquipmentId}
            showEditEquipModal={showEditEquipModal}
            toggleEditEquipModal={this.toggleEditEquipModal}
            isNew={isNew}
          />
        )}
        {showUploadModal && (
          <EquipmentUploadModal
            projectId={projectId}
            showUploadModal={showUploadModal}
            toggleUploadModal={this.toggleUploadModal}
          />
        )}
        {showAlert_deleteEquipment && selectedEquipment && (
          <AlertModal
            alertTitle="Delete Equipment"
            alertTitleClass="bg-danger text-white"
            alertText={`Are you sure you want to delete the following equipment?\n${selectedEquipment.numberMakeDesc}`}
            alertTitleIcon="exclamation-triangle"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            toggleAlertModal={this.toggleAlert_deleteEquipment}
            handleAlertAction={this.handleAlert_deleteEquipment}
            showAlertModal={showAlert_deleteEquipment}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projEquipList: state.equipment.projEquipLists[ownProps.projectId] || null,
  allAvailableEquipList: state.equipment.allAvailableEquipLists[ownProps.projectId] || null,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  user: state.authentication.user,
});

export default connect(mapStateToProps)(EquipmentList);
